<div style="overflow: scroll;" class="wrapperlanding justify-content-center align-items-center ">
  <div style="max-width:1500px;height:auto;" class="container-fluid container-xxl container-fluid-zoom  m-0 p-0 d-flex flex-wrap">
    <div  class="d-flex section py-4 fnt-sz-20">
      <div class=" col-7 pl-3 py-0 pr-4 flex-wrap d-flex clearfix ">
        <img  alt="SmartStepLogo" width="60%" height="12%" src="assets/landing/SmartstepLogo.jpg">
        <h3 style="margin-top:-85px;width:max-content"  class="header1 header_firststep col-12 mb-4 pl-0 pb-0 py-0">LET'S TAKE THE 1<sup>ST</sup> STEP TOGETHER</h3>
        <p  style="margin-top:-180px !important" class="m-0 par.a pl-0 py-0 description">The Sagility Smart Step<sup>TM</sup> a Sagility Aging in Place<sup>TM</sup>
          program is a voluntary program offered to you at no additional cost in partnership with Allianz Life Insurance Company.
          Sagility Smart Step<sup>TM</sup> is here to help you learn how to avoid or lower
          the risk of problems that could interfere with healthy aging and doing the things you love!
        </p>
        
        <form style="margin-top:-100px" class="d-flex form-flex-column form_enroll" method="post" data-bs-theme="light">
          <div>
            <button  class="btn buttonactive custom-button1 shadow ms-2 form-button-width  widthinherit fnt-sz-20 txt-align-center" type="submit"
              (click)="registerbtnclick()">Enroll
              Now!</button>
          </div>
          <div class="enrolled">
            Already enrolled? Login below.
          </div>
          <div  class="login">
            <button  class="btn buttonactive custom-button2 shadow ms-2 text-wrap pt-0 form-button-width widthinherit" type="submit"
              (click)="loginbtnclick()">
              <span class="fnt-sz-20 txt-align-center">Login Here</span>
            </button>
          </div>
        </form>           
      </div>
      <div  class=" col-5  pr-0 d-flex align-items-center justify-content-end clearfix clara">
        <div style="display:flex;flex-direction: column;">
        <div>            
          <button  class="btn custom-button2 shadow ms-2 text-wrap pt-0 form-button-width w-100 chatwithclara" type="submit"
          (click)="claraclick()">            
               <span class="fnt-sz-20">Click here to <br> Chat with Clara</span>            
          </button>
        </div>
       
        <div style="height: 600px;"></div>
        <div  class="divvideo" id="divvideo">
          <div  class="pl-2" style="width:500px">
            Want to learn more about the program?<br/>
            Click on the arrow to watch a short<br/>
            video to see how easy it is to register<br/>
            and take your Healthy Aging assessment.
          </div>

          <div class=" row justify-content-center divvideoimage">
            <a rel="noopener noreferrer" target="_blank" href="{{videoPath}}" class="d-inline-block">
              <img src="{{videoIconPath}}" alt="Video" class="videoimage">
            </a>
          </div>
          </div>   
        </div>
        <img  class="clarapic" alt="Clara"  src="assets/landing/clara.png">      
      </div>
    </div>

    <!-- Full-width bottom image with text and image overlay -->
    <div  class="d-flex flex-wrap pb-1 row divbottomwrapper">
      <div id="footer"  class="col-12 flexdirection-row divbottomwrapper-div">
        <div class="col-8 p-0 align-items-center divbottomwrapper-divcontent">
          <div class="footermessage footermessage_fnt-sz">
            You can enroll by phone or contact a care advocate<br/>
            Monday through Friday 8am to 8pm (EST)
          </div>
          <div class="footerphoneno">            
             <h3 id="footerphone">1-888-855-7837</h3>            
          </div>
          
        </div>
        <div *ngIf="isVisiblelogo" class="col-3 d-flex justify-content-center align-items-end">          
          <img style="top: -10px !important;" class="footerlogo" alt="logo" src="{{logoUrl}}" >          
        </div>        
      </div>      
    </div>    
  </div>
</div>

<div style="overflow: scroll;margin:auto" class="mobile-wraper">
  <div   class="container-fluid container-fluid-zoom  m-0 p-0 d-flex flex-wrap">
    <img style="width:95%" class="pl-4 smartsteplogomobile"  alt="SmartStepLogo"  src="assets/landing/SmartstepLogo.jpg">
    <div   class="d-flex section py-4 fnt-sz-16 col-12" >      
      <div style="display: flex;flex-direction: column;">
        <div   id="divdetail" class="divdetailmobile pl-2 py-0 pr-2 flex-wrap d-flex clearfix ">  
        <h3 style="font-size:22px" class="header1 header1mobile col-12 mb-4 pl-0 pb-0 py-3">LET'S TAKE THE 1<sup>ST</sup> STEP TOGETHER</h3>
        <p class="m-0 par.a pl-0 py-0 my-0 descriptionmobile">The Sagility Smart Step<sup>TM</sup> a Sagility Aging in Place<sup>TM</sup>
          program is a voluntary program offered to you at no additional cost in partnership with Allianz Life Insurance Company.
          Sagility Smart Step<sup>TM</sup> is here to help you learn how to avoid or lower
          the risk of problems that could interfere with healthy aging and doing the things you love!
        </p>        
        <form style="position: relative;right: 10px;" class="d-flex form-flex-column-mobile  py-4" method="post" data-bs-theme="light">
          <div>
            <button style="width:135px !important"  class="btn buttonactive custom-button1 shadow ms-2 form-button-width-mobile txt-align-center" type="submit"
            (click)="registerbtnclick()">Enroll Now!</button>
          </div>
          <div style="position: relative;left: -40px !important;" class="enrolled">
            Already enrolled? Login below.
          </div>
          <div  class="login">
            <button class="btn buttonactive custom-button2 shadow ms-2 text-wrap pt-0 form-button-width--mobile txt-align-center" type="submit"
            (click)="loginbtnclick()">
              <span>Login Here</span>
            </button>
          </div>
        </form>     
        
        </div>
        <div style="position: relative;right: 10px;" id="divclara" class="pr-0 py-4 d-flex align-items-center justify-content-start clearfix mr-4">
          <div>
            <button  class="btn  shadow ms-2 text-wrap pt-0 form-button-width w-100 chatwithclaramobile" type="submit" (click)="claraclick()">
               <span >Click here to <br> Chat with Clara</span>              
            </button>
          </div>
          <img  class="clarapicmobile" alt="Clara"  src="assets/landing/clara_mobile.png">   
        </div>
        <p class="m-0 par.a pl-0 py-0 my-0 descriptionmobile">
          <b>Want to learn more about the program?</b><br/>
           Click on the arrow to watch a short<br/>
           video to see how easy it is to register<br/>
           and take your Healthy Aging assessment.
        </p>        
         <div class=" row videomobile justify-content-center my-4">
          <a rel="noopener noreferrer" target="_blank" href="{{videoPath}}" class="d-inline-block">
            <img src="{{videoIconPath}}" alt="Video" class="videoimage">
          </a>
        </div> 
        <p class="m-0 par.a pl-0 py-4 my-0 descriptionmobile">
          You can enroll by phone or contact a care advocate<br/>
                Monday through Friday 8am to 8pm (EST)                
        </p>
        <h3 style="margin-top:-25px !important;text-align: center;font-size:22px"  id="footerphone">1-888-855-7837</h3>        
        <hr class="hr-mobile">
        <div   class="d-flex flex-wrap pb-1 row divbottomwrappermobile">
          <div  style="height:inherit !important" id="footer"  class="col-12 flexdirection-row divbottomwrapper-div">
            <div style="height:inherit !important" class="col-8"></div>
            <div style="height:inherit !important" *ngIf="isVisiblelogo" class="col-4 d-flex justify-content-center align-items-end">          
              <img  class="footerlogomobile pb-0" alt="logo" src="{{logoUrl}}" >          
            </div>        
          </div>      
        </div>  
      </div>    
    </div>         
  </div>
</div>

<div class="container-fluid tab-wraper">
  <div class="row">
    <img class="pl-5"  alt="SmartStepLogo" width="80%"  src="assets/landing/SmartstepLogo.jpg">
  </div>
  <div class="row mt-3">
    <div class="col-8 pl-5">
      <h3 style="font-size: 23px;"  class="header1 col-12 mb-4 pl-0  pb-0 py-3">LET'S TAKE THE 1<sup>ST</sup> STEP TOGETHER</h3>
      <p  class="m-0 par.a pl-0 py-0 descriptiontab">The Sagility Smart Step<sup>TM</sup> a Sagility Aging in Place<sup>TM</sup>
        program is a voluntary program offered to you at no additional cost in partnership with Allianz Life Insurance Company.
        Sagility Smart Step<sup>TM</sup> is here to help you learn how to avoid or lower
        the risk of problems that could interfere with healthy aging and doing the things you love!
      </p>
      <form class="d-flex form-flex-column form_enroll_tab" method="post" data-bs-theme="light">
        <div>
          <button style="width: 50% !important;margin-top: 40px;"  class="btn buttonactive custom-button1 shadow ms-2 form-button-width  widthinherit fnt-sz-20 txt-align-center" type="submit"
            (click)="registerbtnclick()">Enroll Now!</button>
        </div>
        <div style="position: relative;" class="enrolled">
          Already enrolled? Login below.
        </div>
        <div  class="login">
          <button style="width: 50% !important;" class="btn buttonactive custom-button2 shadow ms-2 text-wrap pt-0 form-button-width widthinherit" type="submit"
            (click)="loginbtnclick()">
            <span class="fnt-sz-20 txt-align-center">Login Here</span>
          </button>
        </div>
      </form>
    </div>
    <div style="position: relative;top: -65px;" class="col-4">
       
            <button  class="btn custom-button2 shadow ms-2 text-wrap pt-0 form-button-width w-100 chatwithclaratab" type="submit" (click)="claraclick()">
              <span class="fnt-sz-20">Click here to <br> Chat with Clara</span>         
            </button>
        
      <img   alt="Clara"  src="assets/landing/clara_tab.png">
    </div>
  </div>
  <div   class="row mt-5 pl-4">    
    <div   class="d-flex">
      <div style="border-left: 2px solid #1D88;border-bottom: 2px solid #1D88;border-top: 2px solid #1D88;" class="col-8 py-4">
        <h6 style="font-size: larger;text-align: center;width: 150%;">
          <b style="font-weight:900">Want to learn more about the program?</b><br/>
          Click on the arrow to watch a short
          video to see how easy it is to register
          and take your Healthy Aging assessment.</h6>
      </div>
          <div style="border-right: 2px solid #1D88;border-bottom: 2px solid #1D88;border-top: 2px solid #1D88;margin-left:-65px" class=" col-6 row justify-content-center divvideoimage">
            <a style="position: relative;left:210px;" rel="noopener noreferrer" target="_blank" href="{{videoPath}}" class="d-inline-block">
              <img src="{{videoIconPath}}" alt="Video" class="videoimage">
            </a>
          </div>
    </div>
   </div>
   <div style="text-align:center;position:relative;line-height: 2.5rem;top:30px;margin-bottom:150px" class="col-12 p-0 align-items-center">
    <div style="font-size: larger;" class="footermessagetab footermessage_fnt-sz">
      You can enroll by phone or contact a care advocate<br/>
      Monday through Friday 8am to 8pm (EST)
      <h3 style="font-weight:700" id="footerphone">1-888-855-7837</h3> 
    </div>         
  </div>       
  <div   class="d-flex row pl-4">       
    <div id="footer"   class="col-12 flexdirection-row-tab-footerlogo divbottomwrapper-div">
      <div class="col-12"></div>      
      <div *ngIf="isVisiblelogo" class="col-4 d-flex justify-content-center align-items-end">          
        <img style="padding:5px;width:115%;background-color: #05205F;" alt="logo" src="{{logoUrl}}" >          
      </div>        
    </div>      
  </div>
</div>
